import { useEffect, useRef, useState } from "react";
import { Size } from "../utils/types";

export function useContentSize(enabled: boolean = true) {
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<Size | null>(null);

  useEffect(() => {
    if (!ref.current || !enabled) return;

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      setSize({ width, height });
    });

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [enabled]);

  return { ref, size };
}

export function saveContentSize(ref: React.RefObject<HTMLElement>, key: string = "loginCardSize") {
  if (ref.current) {
    const { width, height } = ref.current.getBoundingClientRect();
    const size = JSON.stringify({ width, height });
    sessionStorage.setItem(key, size);
  }
}

export function getSavedContentSize(key: string = "loginCardSize"): Size | null {
  const sizeStr = sessionStorage.getItem(key);
  if (sizeStr) {
    try {
      return JSON.parse(sizeStr) as Size;
    } catch {
      return null;
    }
  }
  return null;
}